import * as React from "react"

export default function XtwitterIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.712 8.622L18.413 1h-1.588l-5.818 6.618L6.36 1H1l7.027 10.007L1 19h1.588l6.144-6.989L13.64 19H19L11.712 8.622zm-2.175 2.474l-.712-.997L3.16 2.17H5.6l4.571 6.4.712.996 5.943 8.319h-2.439l-4.85-6.788z"
        fill={props.fill}
      />
    </svg>
  )
}
